import { get, post, put, del } from './base'

export const getAll = () => get('roles').then(roles => roles || [])
export const getOne = roleId => get(`roles/${roleId}`)

export const create = role => post('roles', role)
export const update = (roleId, role) => put(`roles/${roleId}`, role)
export const remove = roleId => del(`roles/${roleId}`)
